// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/diagnostics/Customer/style.css
// module id = 1621
// module chunks = 0